import { styled } from '@mui/material';
import React, { Suspense } from 'react';
import { useFullScreenHandle } from 'react-full-screen';
import { darkGray } from '../../../../theme/color-constants';
import { EXPORT_REF_ID } from '../../../constants';
import { FullHeightFullScreen } from '../../styles';
import { SideBar } from '../sidebar/SideBar';
import { DashboardPageOptionsContext } from './contexts';
import CustomPage from './CustomPage';
import { usePageHandle } from './hooks';
import { DashboardConfig } from './types';

const StyledCustomPageWrapper = styled('div')<{ $fullScreenActive: boolean }>`
  height: ${(props) => (props.$fullScreenActive ? '100%' : 'inherit')};
  background-color: ${(props) =>
    props.$fullScreenActive ? darkGray : 'inherit'};
`;

const StyledWrapper = styled('div')`
  width: 100%;
  height: 100%;
`;

interface CustomDashboardProps {
  dashboardConfig: DashboardConfig;
  selectedPageNumber: number;
}

const CustomDashboard = (props: CustomDashboardProps) => {
  const fullScreenHandle = useFullScreenHandle();

  const pageHandle = usePageHandle(
    props.dashboardConfig,
    props.selectedPageNumber
  );

  if (pageHandle.selected) {
    const pageConfig = pageHandle.selected;
    return (
      <DashboardPageOptionsContext.Provider
        value={pageConfig.pageOptions ?? {}}
      >
        <StyledWrapper>
          <Suspense>
            <SideBar
              pageHandle={pageHandle}
              fullScreenHandle={fullScreenHandle}
              backgroundColor="whitesmoke"
            />
          </Suspense>
          <FullHeightFullScreen
            handle={fullScreenHandle}
            $fullScreenActive={fullScreenHandle.active}
          >
            <StyledCustomPageWrapper
              $fullScreenActive={fullScreenHandle.active}
              id={EXPORT_REF_ID}
            >
              <CustomPage
                key={pageHandle.selected.pageId}
                pageConfig={pageConfig}
              />
            </StyledCustomPageWrapper>
          </FullHeightFullScreen>
        </StyledWrapper>
      </DashboardPageOptionsContext.Provider>
    );
  } else {
    return <div>Page not found</div>;
  }
};

export default CustomDashboard;
